import { Link } from 'react-router';

// Import hooks
import useHashLinkClick from '../../hooks/ui/useHashLinkClick';

type HeroProps = {
  onStartClick: () => void;
  onViewSavedClick?: () => void;
};

export default function Hero({ onStartClick, onViewSavedClick }: HeroProps) {
  const onHashLinkClick = useHashLinkClick();

  return (
    <section id="hero" className="text-center py-20 md:py-24 px-4">
      <h1 className="text-3xl sm:text-5xl font-extrabold mb-4 tracking-tight leading-tight">
        <span className="block text-black md:text-balance">
          Find the time that works for everyone with
        </span>
        <span className="block text-blue-600 md:text-balance">WhenWeMeet?</span>
      </h1>
      <p className="text-gray-600 mb-6 max-w-2xl mx-auto text-sm sm:text-lg">
        Group scheduling made simple. Plan group meetings in minutes. Share a
        single link, collect availability, and pick the best time without
        calendar conflicts.
      </p>
      <button
        className="bg-green-700 text-white px-6 py-3 rounded-lg text-base font-medium sm:text-lg hover:bg-green-800 w-full sm:w-auto shadow-lg hover:shadow-xl transition-shadow"
        onClick={onStartClick}>
        Create a Meeting Planner
      </button>
      {onViewSavedClick && (
        <p className="mt-3">
          <button
            type="button"
            onClick={onViewSavedClick}
            className="text-sm text-green-700 font-medium hover:underline">
            View saved planners on this device
          </button>
        </p>
      )}
      <p className="text-gray-500 mt-4 mb-6 text-xs sm:text-sm">
        <Link
          to="/#pricing"
          className="hover:underline"
          onClick={(e) => onHashLinkClick(e, 'pricing')}>
          Free forever
        </Link>{' '}
        •{' '}
        <Link
          to="/#features"
          className="hover:underline"
          onClick={(e) => onHashLinkClick(e, 'features')}>
          No sign‑up required
        </Link>{' '}
        •{' '}
        <Link to="/app" className="hover:underline">
          Cross-platform
        </Link>
      </p>
    </section>
  );
}
